import { Observable } from 'rxjs';
import { ResultadoFilaMasivaErrorDto } from '../../model/gestiones-masivas/resultado-fila-masiva-error.dto';

/**
 * Puerto (interfaz) para exportar errores masivos a Excel.
 * Cumple patrón hexagonal: el dominio no depende de infraestructura.
 */
export abstract class ExportarErroresMasivosRepository {
  abstract exportarErrores(errores: ResultadoFilaMasivaErrorDto[]): Observable<Blob>;
}
